import { useMemo } from 'react'
import { BrickWall } from 'lucide-react'
import type { AdminColumn } from '@/components/DataTable/types'
import { SecCrudTable, type SecField } from './SecCrudTable'
import { SEC_STR as S, type WafRuleRow } from './securityMoreApi'

/**
 * A18.18 — WAF qoidalari. Admin-managed WAF ruleset (`sec_waf_rules`, 000248):
 * a match `pattern` + `action` + on/off toggle, curated by hand. Real CRUD via
 * `/admin/security/waf-rules` — the admin owns this ruleset directly.
 */
const ACTION_OPTS = [
  { value: 'block', label: 'block' },
  { value: 'challenge', label: 'challenge' },
  { value: 'log', label: 'log' },
]

export function WafRulesScreen() {
  const columns = useMemo<AdminColumn<WafRuleRow>[]>(
    () => [
      { key: 'name', header: S.ruleName, type: 'text', width: 180 },
      { key: 'pattern', header: S.wafPattern, type: 'text', minWidth: 220 },
      {
        key: 'action',
        header: S.action,
        type: 'enum',
        width: 130,
        options: [
          { value: 'block', label: 'block', status: 'blocked' },
          { value: 'challenge', label: 'challenge', status: 'review' },
          { value: 'log', label: 'log', status: 'pending' },
        ],
      },
      { key: 'enabled', header: S.enabledLbl, type: 'bool', width: 90, align: 'center' },
      { key: 'updated_at', header: S.updated, type: 'date', width: 150 },
    ],
    [],
  )

  const fields = useMemo<SecField[]>(
    () => [
      { name: 'pattern', placeholder: S.wafPattern, mono: true },
      { name: 'name', placeholder: S.ruleName },
      { name: 'action', placeholder: S.action, type: 'select', options: ACTION_OPTS },
      { name: 'enabled', placeholder: S.enabledLbl, type: 'checkbox', defaultValue: 'true' },
    ],
    [],
  )

  return (
    <SecCrudTable<WafRuleRow>
      screenId="A18.18"
      title={S.waf}
      addLabel={S.addWaf}
      path="/admin/security/waf-rules"
      listKey="rules"
      searchKeys={['name', 'pattern', 'action']}
      fields={fields}
      requiredField="pattern"
      columns={columns}
      icon={<BrickWall size={28} strokeWidth={1.5} />}
    />
  )
}
